import { isCanadaAppHandler } from '../helpers/common';

const canadaApiGWBaseURL = 'https://ca-mobile.apigw.recyclecoach.com';
const usApiGWBaseURL = 'https://us-mobile.apigw.recyclecoach.com';

const apiGWUrl = isCanadaAppHandler() ? canadaApiGWBaseURL : usApiGWBaseURL;

export const acquireBadge = () => `${apiGWUrl}/user/badges`;
